module.exports = __webpack_public_path__ + "static/media/arrow_down_white.3ed14eba.svg";